export const PUBLIC_LAYOUT = "default-layout";
